import { AUTH_SERVICE } from "@/datas/authservice";

export default Object.freeze({
  display: (value) => {
    return value === "T" ? "진열" : "진열안함";
  },
  selling: (value) => {
    return value === "T" ? "판매중" : "판매안함";
  },
  certStatus: (value) => {
    if (value === "inactivated") {
      return "미인증";
    } else if (value === "activated") {
      return "인증완료";
    } else if (value === "lost") {
      return "분실";
    } else if (value === "approved") {
      return "승인완료";
    } else {
      return "-";
    }
  },
  defaultString: (value) => {
    return !value ? "-" : value;
  },
  defaultDate: (value) => {
    if (!value) {
      return "-";
    } else {
      let date = value.split(" ");
      return `${date[0]}</br>${date[1]}`;
    }
  },
  numberFormat: (value) => {
    if (!value) {
      return value;
    } else {
      value += "";
      var whole, fraction;
      let decIndex = value.lastIndexOf(".");
      if (decIndex > 0) {
        whole = value.substr(0, decIndex);
        fraction = value.substr(decIndex);
      } else {
        whole = value;
      }
      let rgx = /(\d+)(\d{3})/;
      while (rgx.test(whole)) {
        whole = whole.replace(rgx, "$1" + "," + "$2");
      }
      return fraction ? whole + fraction : whole;
    }
  },
  excelErrorMessages: (data) => {
    return data.toString().replace(",", "</br>");
  },
  validatedAndExpiredAt: (data) => {
    if (data.cert_validated_at && data.cert_expired_at) {
      let validatedAt = data.cert_validated_at.substr(0, 10);
      let expiredAt = data.cert_expired_at.substr(0, 10);
      return `${validatedAt}</br>~${expiredAt}`;
    } else {
      return "-";
    }
  },
  warrantyPeriod: (data) => {
    let items = {
      d: "일",
      m: "개월",
      y: "년",
    };
    if (
      data.cert_validated_at !== null &&
      data.cert_validated_at !== undefined &&
      data.cert_duration_type !== AUTH_SERVICE.BOUGHT
    ) {
      let validatedAt = data.cert_validated_at.substr(0, 10);
      let expiredAt = data.cert_expired_at.substr(0, 10);
      return `${validatedAt}</br>~${expiredAt}`;
    } else {
      let count = data.cert_duration.replace(/[a-z]/gi, "");
      let type = data.cert_duration.replace(/[0-9]/g, "");
      let text = "";

      // 구매일 기준
      if (
        data.cert_duration_type == AUTH_SERVICE.BOUGHT &&
        data.bought_at &&
        data.cert_duration
      ) {
        let validatedAt = data.bought_at.substr(0, 10);
        let date = new Date(validatedAt);
        let y = 0;
        let m = 0;
        let d = 0;
        if (type == "y") {
          y += Number(count);
          date.setFullYear(date.getFullYear() + y);
        }
        if (type == "m") {
          m += Number(count);
          date.setMonth(date.getMonth() + m);
        }
        if (type == "d") {
          d += Number(count);
          date.setDate(date.getDate() + d);
        }
        let yyyy = date.getFullYear().toString();
        let mm = (date.getMonth() + 1).toString();
        let dd = date.getDate().toString();
        let expiredAt =
          yyyy +
          "-" +
          (mm[1] ? mm : "0" + mm[0]) +
          "-" +
          (dd[1] ? dd : "0" + dd[0]);
        return `${validatedAt}</br>~${expiredAt}`;
      }

      if (data.cert_duration_type == AUTH_SERVICE.ACTIVATED) {
        text = "인증일로부터";
      } else if (data.cert_duration_type == AUTH_SERVICE.CREATED) {
        text = "생성일로부터";
      } else {
        text = "구매일로부터";
      }
      return `${text}</br>${count}${items[type]}`;
    }
  },
});
